<template>
  <dynamic-component :template="template"/>
</template>

<script>
import {defineComponent, h} from "vue";

const DynamicComponent = defineComponent({
  props: {
    template: {
      type: String,
      required: true,
    },
  },
  render() {
    return h({
      template: this.template,
    });
  },
});

export default {
  name: "HtmlToComponentWrapper",
  components: {DynamicComponent},
  props: {
    template: {}
  },
}
</script>

<style scoped>

</style>